<template>
<div class='card' >
    <div class='card-header'>
        <label class='az-content-label' style='text-transform: none'>Member Basic Details</label>
    </div>
    <div class='card-body pd-0' v-loading='loading'>
        <div class="az-content-header-right mg-20">
            <div class="media">
                <div class="media-body">
                <label>Trustee Structure</label>
                <h6 class='tx-13'>{{trustee.trustee_structure}}</h6>
                </div><!-- media-body -->
            </div><!-- media -->
            <div class="media">
                <div class="media-body">
                <label>Corporarte Trustee Name</label>
                <h6 class='tx-13'>{{isSample?'Sample Family Trustee Pty Ltd ':(trustee.corporate_trustee_name?trustee.corporate_trustee_name:'N/A')}}</h6>
                </div><!-- media-body -->
            </div><!-- media -->
            <div class="media">
                <div class="media-body">
                <label>ACN</label>
                <h6 class='tx-13'>{{isSample?'123456789':(trustee.corporate_trustee_acn?trustee.corporate_trustee_acn:'N/A')}}</h6>
                </div><!-- media-body -->
            </div><!-- media -->
        </div><!-- az-content-header -->
        <div class='media-wrap'>
            <div class='media' v-for='(member,index) in members' :key='member.id' style='width:48%;margin-right:2%;margin-top:2%'>
                <div class='media-body'>
                    <el-tabs type="border-card">
                        <el-tab-pane>
                            <span slot="label"><i class="el-icon-user-solid"></i> {{isSample?'Mr Mike Sample '+(index+1):member.trustee_name}} <span v-show='member.is_member' class="badge badge-primary">Member</span></span>
                            <el-descriptions style='font-size:13px' title="" :column="1" size="" border>
                                <el-descriptions-item>
                                <template slot="label">
                                    Date of Birth
                                </template>
                                {{dateformats.AUformat(member.date_of_birth.slice(0,10))}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    Age
                                </template>
                                {{dateformats.getAge(member.date_of_birth)}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    Account Type
                                </template>
                                {{member.member_account_type}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    Insurance Cover
                                </template>
                                {{member.insurance_recorded?'Yes':'No'}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-location-outline"></i>
                                    Address
                                </template>
                                {{isSample?'691 Burke Rd. Camberwell VIC 3164':member.address_line1+' '+member.locality+' '+member.state+' '+member.postcode}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-mobile-phone"></i>
                                    Phone
                                </template>
                                {{isSample?'0400000001':(member.phone?member.phone:'-')}}
                                </el-descriptions-item>
                                <el-descriptions-item>
                                <template slot="label">
                                    <i class="el-icon-message"></i>
                                    Email
                                </template>
                                {{isSample?'sample_trustee_email@gmail.com.au':(member.email?member.email:'-')}}
                                </el-descriptions-item>
                                
                            </el-descriptions>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import dateformats from '../../../utils/dateformats'
export default {
  name: 'memberbasic',
  components: {
    
  },
  data(){
      return{
         isSample:false,
         dateformats:dateformats,
         trustee:{},
         members:[],
         loading:true
      }
  },
  created(){
        this.getMembers();
    },
  methods:{
        getMembers: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            this.$api.funddashboard_api.fundMember(this.$route.params.fund_code).then(response =>{
                //note that the data for prev year and this year is reversed
                this.trustee=response.data['trustee']
                this.members=response.data['members']
                this.loading=false
            });
        
        },
    }
}
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: black;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: black;
}
.el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #EBEEF5;
    padding: 10px 10px;
}
</style>
<style scoped>
.media-wrap{
    display: flex;
    flex-wrap:wrap;
    padding:0;
    margin-left:20px;
    margin-bottom:20px;
}
</style>